export const MenuType = {
    TOP_MENU: 'TOP_MENU',
    POP_MENU: 'POP_MENU',
    TOOLBAR: 'TOOLBAR',
    FLOAT: 'FLOAT',
    PROPERTY_BAR: 'PROPERTY_BAR', // 属性设置侧边栏
    STYLE_PANEL: 'STYLE_PANEL',
    QUICK_SETTING: 'QUICK_SETTING', // 快捷设置
    GUIDES_SETTING: 'GUIDES_SETTING', // 参考线
    THEME_SETTING: 'THEME_SETTING', // 主题
};
export type IMenuType = typeof MenuType[keyof typeof MenuType];
